// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__-8KZj"};